/* eslint-disable  */
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import {
  authActionCreators,
  userDataActionCreators,
} from "../../../../service/action-creators";
import Loader from "../../../Loader";
import RenderHome from "../../home/RenderHome";
import "./ApplyLoans.css";
import Loan_chip from "./components/Loan_chip";

const inputCls = "mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent";
const readonlyCls = "mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm text-sm cursor-not-allowed";
const textareaCls = "mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none";

const Field = ({ label, required, error, children }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700">
      {label}{required && <span className="text-red-500 ml-0.5">*</span>}
    </label>
    {children}
    {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
  </div>
);

function LoanDetailed() {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    SubmitUpdateLoanFormOne,
    ResetUserDataResponse,
    GetFormOneAppliedLoanTemp,
  } = bindActionCreators(userDataActionCreators, dispatch);
  const { GetUserProfile } = bindActionCreators(authActionCreators, dispatch);

  const [formState] = useState(4);
  const [formData, setFormData] = useState({});
  const [loanTerm, setLoanTerm] = useState(null);
  const [monthlyDeduction, setMonthlyDeduction] = useState(0);
  const [formError, setFormError] = useState({});

  const response = useSelector((state) => state?.user?.response);
  const isLoading = useSelector((state) => state?.user?.isLoading);
  const user = useSelector((state) => state?.auth?.user);
  const userData = useSelector((state) => state?.user);
  const { loanTemp } = userData;

  const INTEREST_RATE = 11 / 100;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    GetUserProfile();
    GetFormOneAppliedLoanTemp();
  }, []);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      loanAmount: loanTemp?.loanAmount,
      monthlyDeduction: loanTemp?.monthlyDeduction,
      loanTerm: loanTemp?.loanTerm,
      affordability: loanTemp?.affordability,
      mandateNumber: loanTemp?.mandateNumber,
      otpNumber: loanTemp?.otpNumber,
      purposeForLoan: loanTemp?.purposeForLoan,
      bank_account_holder_name: loanTemp?.bank_account_holder_name,
      bank_account_number: loanTemp?.bank_account_number,
      bank_branch: loanTemp?.bank_branch,
      bank_name: loanTemp?.bank_name,
    }));
  }, [loanTemp]);

  useEffect(() => {
    if (Number(formData.loanAmount) && Number(formData?.affordability) && Number(formData?.loanTerm)) {
      const FEE_CHARGE = (3 / 100) * Number(formData.loanAmount);
      let convertedDuration = 0;
      const term = Number(formData.loanTerm);
      if (term === 18) convertedDuration = 1.5;
      else if (term === 24) convertedDuration = 2;
      else if (term === 36) convertedDuration = 3;
      else if ([1, 3, 6, 12].includes(term)) convertedDuration = 1;

      const loanPeriod = (convertedDuration * INTEREST_RATE) + 1;
      const calc = Number(formData.loanAmount) * loanPeriod;
      const initialAmount = calc + FEE_CHARGE;
      setMonthlyDeduction(Number(initialAmount / term).toFixed(2));
    }
  }, [formData.loanTerm, formData.loanAmount, formData?.affordability]);

  const handleFormChange = (e) => {
    e.preventDefault();
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    const err = {};
    const numberRegex = /^[0-9]+$/;
    if (!formData.loanAmount) err.loanAmount = "Loan amount is required";
    else if (!numberRegex.test(formData.loanAmount)) err.loanAmount = "Please only enter the amount to be received";
    if (!formData.affordability) err.affordability = "Affordability is required";
    if (!formData.loanTerm) err.loanTerm = "Loan term is required";
    if (!formData.mandateNumber) err.mandateNumber = "Mandate number is required";
    if (!formData.otpNumber) err.otpNumber = "OTP is required";
    if (!formData.purposeForLoan) err.purposeForLoan = "Loan purpose is required";
    if (!formData.bank_account_holder_name) err.bank_account_holder_name = "Account holder name is required";
    if (!formData.bank_account_number) err.bank_account_number = "Account number is required";
    if (!formData.bank_name) err.bank_name = "Name of bank is required";
    if (!formData.bank_branch) err.bank_branch = "Bank branch is required";
    setFormError({ ...err });
    return Object.keys(err).length < 1;
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      SubmitUpdateLoanFormOne({ ...loanTemp, ...formData, monthlyDeduction }, loanTemp?._id);
    }
  };

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      ResetUserDataResponse();
      history.push("/apply-loan-uploads");
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetUserDataResponse(), 1500);
    } else if (response?.state === "DELETED") {
      toast.success(response?.message);
      history.push("/apply-loan-personal_info");
      setTimeout(() => ResetUserDataResponse(), 1500);
    }
  }, [response?.state, response?.message, response?.action]);

  return (
    <div className="ApplyLoans">
      <RenderHome title="Apply Loan">
        {isLoading && <Loader />}

        <Loan_chip formState={formState} />

        <form onSubmit={(e) => e.preventDefault()} style={{ maxWidth: "800px", margin: "0 auto", padding: "0 1rem 2rem" }}>

          {/* Loan Details */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Loan Details</h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <Field label="Loan Amount (&#8373;)" required error={formError.loanAmount}>
                <input type="number" name="loanAmount"
                  defaultValue={loanTemp?.loanAmount}
                  placeholder="Enter loan amount" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="Remaining Affordability (&#8373;)" required error={formError.affordability}>
                <input type="number" name="affordability"
                  defaultValue={loanTemp?.affordability}
                  placeholder="Enter remaining affordability" onChange={handleFormChange} className={inputCls} />
              </Field>
            </div>

            <div className="mb-4">
              <FormControl component="fieldset" style={{ width: "100%" }}>
                <FormLabel component="legend" style={{ fontSize: "0.875rem", fontWeight: 500, color: "#374151", marginBottom: "0.25rem" }}>
                  Loan Term (Months)<span style={{ color: "red" }}>*</span>
                  {(loanTemp?.loanTerm || loanTerm) && (
                    <span className="ml-3 text-sm">
                      Selected: <span className="bg-green-600 text-white px-2 py-0.5 rounded-full text-xs font-semibold">{loanTemp?.loanTerm ?? loanTerm} months</span>
                    </span>
                  )}
                </FormLabel>
                <RadioGroup row name="row-radio-buttons-group" className="flex gap-4 flex-wrap mt-1">
                  {["6", "12", "18", "24", "36"].map((val) => (
                    <FormControlLabel key={val} value={val} control={<Radio size="small" />} label={val}
                      name="loanTerm"
                      defaultChecked={loanTemp?.loanTerm === val}
                      onChange={(e) => { handleFormChange(e); setLoanTerm(e.target.value); }}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              {formError.loanTerm && <p className="text-red-500 text-xs mt-1">{formError.loanTerm}</p>}
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
              <Field label="Monthly Deduction (&#8373;)">
                <input type="text" name="monthlyDeduction" readOnly value={monthlyDeduction}
                  className={readonlyCls} placeholder="Auto-calculated" />
              </Field>
              <Field label="Mandate Number" required error={formError.mandateNumber}>
                <input type="text" name="mandateNumber"
                  defaultValue={loanTemp?.mandateNumber}
                  placeholder="Enter mandate number" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="OTP Number" required error={formError.otpNumber}>
                <input type="number" name="otpNumber"
                  defaultValue={loanTemp?.otpNumber}
                  placeholder="Enter OTP number" onChange={handleFormChange} className={inputCls} />
              </Field>
            </div>

            <Field label="Purpose of Loan" required error={formError.purposeForLoan}>
              <textarea name="purposeForLoan" rows={3}
                defaultValue={loanTemp?.purposeForLoan}
                placeholder="Describe the purpose of the loan"
                onChange={handleFormChange} className={textareaCls} />
            </Field>
          </div>

          {/* Bank Details */}
          <div className="bg-white p-6 rounded-lg shadow-md mb-4">
            <h3 className="text-xl font-semibold mb-4 text-gray-800">Bank Details</h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
              <Field label="Account Holder Name" required error={formError.bank_account_holder_name}>
                <input type="text" name="bank_account_holder_name"
                  defaultValue={loanTemp?.bank_account_holder_name}
                  placeholder="Account holder name" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="Bank Name" required error={formError.bank_name}>
                <input type="text" name="bank_name"
                  defaultValue={loanTemp?.bank_name}
                  placeholder="Enter bank name" onChange={handleFormChange} className={inputCls} />
              </Field>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <Field label="Account Number" required error={formError.bank_account_number}>
                <input type="text" name="bank_account_number"
                  defaultValue={loanTemp?.bank_account_number}
                  placeholder="Enter account number" onChange={handleFormChange} className={inputCls} />
              </Field>
              <Field label="Bank Branch" required error={formError.bank_branch}>
                <input type="text" name="bank_branch"
                  defaultValue={loanTemp?.bank_branch}
                  placeholder="Enter bank branch" onChange={handleFormChange} className={inputCls} />
              </Field>
            </div>
          </div>

          <div className="flex justify-between mt-2">
            <button type="button"
              onClick={() => history.push("/apply-loan-employment")}
              className="px-6 py-2.5 bg-white text-gray-700 font-medium text-sm rounded-lg border border-gray-400 hover:bg-gray-100 focus:outline-none">
              Back
            </button>
            <button type="button" onClick={handleFormSubmit}
              className="px-6 py-2.5 bg-green-700 text-white font-medium text-sm rounded-lg hover:bg-green-800 focus:outline-none">
              Save and continue
            </button>
          </div>

        </form>
      </RenderHome>
      <ToastContainer autoClose={3000} />
    </div>
  );
}

export default LoanDetailed;
